import PropTypes from 'prop-types';
import React from 'react';

const CONDUCTOR_ICON_PATH = 'M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z';

export const ClaudeLogo = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 1200 1200" fill="none" aria-hidden="true">
    <path fill="#D97757" d="M233.96 800.21L468.64 668.54l3.95-11.44-3.95-6.36h-11.44l-39.22-2.42-134.09-3.62-116.3-4.83-112.67-6.04L26.58 627.79 0 592.75l2.74-17.48 23.84-16.03 34.15 2.98 75.46 5.15 113.24 7.81 82.14 4.83 121.7 12.65h19.33l2.74-7.81-6.6-4.83-5.16-4.83L346.39 495.79 219.54 411.87l-66.44-48.32-35.92-24.48-18.12-22.95-7.81-50.1 32.62-35.92 43.81 2.98 11.2 2.98 44.37 34.15 94.79 73.37 123.79 91.17 18.12 15.06 7.25-5.15.89-3.63-8.13-13.63-67.47-121.69-71.84-123.79-31.97-51.3-8.46-30.76c-2.98-12.64-5.15-23.27-5.15-36.24l37.13-50.42 20.54-6.6 49.53 6.6 20.86 18.12 30.77 70.39 49.85 110.82 77.32 150.68 22.63 44.7 12.08 41.4 4.51 12.64h7.81v-7.25l6.36-84.89 11.76-104.21 11.44-134.09 3.95-37.77 18.68-45.26 37.13-24.48 28.99 13.85 23.84 34.15-3.3 22.07-14.17 92.13-27.79 144.32-18.12 96.64h10.55l12.08-12.08 48.89-64.91 82.15-102.69 36.24-40.75 42.28-45.02 27.14-21.42h51.3l37.77 56.13-16.91 57.99-52.83 67.01-43.81 56.78-62.82 84.56-39.22 67.65 3.63 5.4 9.34-0.89 141.91-30.2 76.67-13.85 91.49-15.7 41.4 19.33 4.51 19.65-16.27 40.19-97.85 24.16-114.77 22.95-170.9 40.43-2.09 1.53 2.42 2.98 76.99 7.25 32.94 1.77 80.62 0 150.12 11.19 39.22 25.93 23.52 31.73-3.95 24.16-60.4 30.77-81.5-19.33-190.23-45.26-65.46-16.27-9.02 0v5.4l54.36 53.15 99.62 89.96 124.75 115.97 6.36 28.67-16.03 22.63-16.91-2.42-109.61-82.47-42.28-37.13-95.76-80.62-5.56 0v8.46l22.07 32.3 116.54 175.17 6.04 53.72-8.46 17.48-30.2 10.55-33.18-6.04-68.21-95.76-70.39-107.84-56.78-96.64-6.93 3.95-33.5 360.89-15.7 18.44-36.24 13.85-30.2-22.95-16.03-37.13 16.03-73.37 19.33-95.76 15.7-76.11 14.17-94.55 8.46-31.41-.56-2.09-6.93.89-71.23 97.85-108.4 146.5-85.77 91.81-20.54 8.13-35.6-18.44 3.3-32.94 19.93-29.32 118.64-150.93 71.6-93.58 46.23-52.19-.32-7.81-2.74 0L205.29 929.4l-56.13 7.25-24.16-22.63 2.98-37.13 11.44-12.08 94.79-65.24-.32.32z" />
  </svg>
);

ClaudeLogo.propTypes = {
  size: PropTypes.number
};

export const ConductorMiniIcon = ({ size = 18 }) => (
  <svg viewBox="-1 -1 26 26" style={{ width: size, height: size, overflow: 'visible' }} aria-hidden="true">
    <defs>
      <linearGradient id="mcp-conductor-gradient" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#2A9CE4">
          <animate attributeName="stop-color" values="#2A9CE4;#2A9CE4;#4A8FD9;#2A9CE4;#2A9CE4" keyTimes="0;0.4;0.55;0.7;1" dur="4s" repeatCount="indefinite" />
        </stop>
        <stop offset="0.5" stopColor="#957BA1">
          <animate attributeName="stop-color" values="#957BA1;#957BA1;#7B61FF;#957BA1;#957BA1" keyTimes="0;0.4;0.55;0.7;1" dur="4s" repeatCount="indefinite" />
          <animate attributeName="offset" values="0.5;0.5;0.35;0.65;0.5" keyTimes="0;0.4;0.55;0.7;1" dur="4s" repeatCount="indefinite" />
        </stop>
        <stop offset="1" stopColor="#FF595E">
          <animate attributeName="stop-color" values="#FF595E;#FF595E;#2A9CE4;#FF595E;#FF595E" keyTimes="0;0.4;0.55;0.7;1" dur="4s" repeatCount="indefinite" />
        </stop>
      </linearGradient>
    </defs>
    <path
      d={CONDUCTOR_ICON_PATH}
      fill="none"
      stroke="url(#mcp-conductor-gradient)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ConductorMiniIcon.propTypes = {
  size: PropTypes.number
};

const LOGO_TILE_STYLE = {
  width: '28px',
  height: '28px',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0
};

export const LogoLockup = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
    <div style={{ ...LOGO_TILE_STYLE, background: 'var(--od-c-fdf4f0, #FDF4F0)', border: '1px solid var(--od-c-f4d8cc, #F4D8CC)' }}>
      <ClaudeLogo size={18} />
    </div>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
      <path d="M4 8h8M9 5l3 3-3 3" stroke="var(--od-border, #D5D7DA)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <div style={{ ...LOGO_TILE_STYLE, background: 'var(--od-surface-2, #F5F5F5)', border: '1px solid var(--od-border-2, #E9EAEB)' }}>
      <ConductorMiniIcon size={16} />
    </div>
  </div>
);
